import type { PayloadAction } from '@reduxjs/toolkit';
import type { PeopleState } from 'shared/interfaces/people.interface';

import { createSlice } from '@reduxjs/toolkit';

import { getPeopleThunk, getPersonThunk } from './people.thunks';

const initialState: PeopleState = {
  list: [],
  current: null,
  selected: {
    forAgency: {
      peopleId: null,
    },
    forDivision: {
      peopleId: null,
    },
  },
};

const peopleSlice = createSlice({
  name: 'people',
  initialState,
  reducers: {
    removePeopleFromStore: (state) => {
      state.current = null;
    },
    setSelectedPeopleForAgency: (
      state,
      action: PayloadAction<{ peopleId: number }>,
    ) => {
      state.selected.forAgency = action.payload;
    },
    setSelectedPeopleForDivision: (
      state,
      action: PayloadAction<{ peopleId: number }>,
    ) => {
      state.selected.forDivision = action.payload;
    },
    clearSelectedPeople: (state) => {
      state.selected = {
        forAgency: { peopleId: null },
        forDivision: { peopleId: null },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPeopleThunk.fulfilled, (state, action) => {
      state.list = action.payload.rows;
    });

    builder.addCase(getPersonThunk.fulfilled, (state, action) => {
      state.current = action.payload;
    });
  },
});

export const {
  clearSelectedPeople,
  removePeopleFromStore,
  setSelectedPeopleForAgency,
  setSelectedPeopleForDivision,
} = peopleSlice.actions;

export const peopleReducer = peopleSlice.reducer;
